import React from 'react';

const TextSectionWithStructuredBullets = ({ title, paragraphs }) => {
  const baseTextStyle = {
    fontSize: 16,
    lineHeight: '24px',
    
    marginBottom: 20,
    color: '#212121',
    fontWeight: 400,
  };

  const titleStyle = {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: 16,
    
    color: '#212121',
  };

  const bulletStyle = {
    ...baseTextStyle,
    paddingLeft: 20,
    marginBottom: 20,
  };

  const bulletItemStyle = {
    listStyleType: 'disc',
    marginBottom: 6,
  };

  return (
    <div style={{ marginBottom: 48 }}>
      {title && <h3 style={titleStyle}>{title}</h3>}

      {paragraphs.map((para, idx) => (
        <div key={idx}>
          {para.text && <p style={baseTextStyle}>{para.text}</p>}
          {para.bullets && para.bullets.length > 0 && (
            <ul style={bulletStyle}>
              {para.bullets.map((item, i) => (
                <li key={i} style={bulletItemStyle}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default TextSectionWithStructuredBullets;
